(function ($) {
    $(() => {

        let options = {
            root: null,
            rootMargin: "0px",
            
        };    
          
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
               
                if (entry.intersectionRatio > 0) {
               
                    $('.loader-press').addClass('show');

                    setTimeout(function () {
                        let post_ids = [];
                        $('.js-tile').each(function( index ) {
                            post_ids.push($(this).data('id'));
                        });

                        var data = {
                            action: 'infinite_scroll',
                            years: $("select[name='years']").val(),
                            topics: $("select[name='topics']").val(),
                            langs: $("select[name='langs']").val(),
                            post_type: $(".js-type").data('type'),
                            post_ids: post_ids,
                        };

                        $.ajax({
                            url: ajax.ajaxurl,
                            type: 'POST',
                            data: data,
                            success(res) {
                                $('.js-articles-wrapper').append(res.data.return_posts);
                                $(document).ready(function () {
                                    $('.match-h').matchHeight({
                                        byRow: true,
                                        property: 'height',
                                        target: null,
                                        remove: false
                                    });    
                                });
                                $('.loader-press').removeClass('show');

                                if(res.data.count === 0) {
                                    $('.loader-press').remove();
                                    $('#infinite-scroll-trigger').remove();
                                }
                            }
                        }).done(response => {
                                
                        });
                    }, 500);

                }
            });
        }, options);
        

        if($('#infinite-scroll-trigger').length > 0) {
            observer.observe(document.querySelector('#infinite-scroll-trigger'));
        }
        
    });
})(jQuery);